import {
  clampProgressPercent,
  clampProgressStep,
  formatProgressStepLabel,
  type OperationProgressLifecycleState,
} from '../../../shared/ui/progress';

export type QuickFillLoadPhase =
  | 'preparing'
  | 'requesting'
  | 'processing'
  | 'building'
  | 'ready'
  | 'error';

export interface QuickFillLoadMetric {
  label: string;
  value: string;
}

export interface QuickFillLoadProgress {
  operationId?: string;
  phase: QuickFillLoadPhase;
  message: string;
  detail?: string;
  currentItem?: string;
  state?: OperationProgressLifecycleState;
  waitReason?: string;
  waitElapsedMs?: number | null;
  activeElapsedMs?: number | null;
  currentStep: number;
  totalSteps: number;
  processed?: number | null;
  total?: number | null;
  percent?: number | null;
  elapsedMs?: number | null;
  etaMs?: number | null;
  cacheStatus?: string;
  resultReady?: boolean;
  metrics?: QuickFillLoadMetric[];
}

export const QUICK_FILL_LOAD_TOTAL_STEPS = 4;

export function clampQuickFillLoadStep(currentStep: number, totalSteps: number): number {
  return clampProgressStep(currentStep, totalSteps, 0);
}

export function getQuickFillLoadPercent(progress?: QuickFillLoadProgress | null): number | null {
  if (!progress) {
    return null;
  }

  const explicitPercent = clampProgressPercent(progress.percent);
  if (explicitPercent !== null) {
    return explicitPercent;
  }

  return null;
}

export function formatQuickFillLoadStep(progress?: QuickFillLoadProgress | null): string {
  if (!progress || progress.totalSteps <= 0) {
    return '';
  }

  return formatProgressStepLabel(progress.currentStep, progress.totalSteps, 0);
}
